import { ReactNode } from "react";
import { useUpdateTask } from "@api/task.api";
import { Task } from "@common/types/task";
import { BlockedBySection } from "./TaskBlockingSection/BlockedBySection";
import { BlockingSection } from "./TaskBlockingSection/BlockingSection";
import { RelatedSection } from "./TaskBlockingSection/RelatedSection";

interface TaskDependencySection {
    label: string;
    content: ReactNode;
}

/** The task's Blocked by, Blocking and Related tasks lists with their labels, for each view to wrap. */
export const useTaskDependencySections = (
    task: Task,
): TaskDependencySection[] => {
    const updateTask = useUpdateTask(task);

    return [
        {
            label: "Blocked by",
            content: (
                <BlockedBySection
                    task={task}
                    onBlockedByChange={(blockedByTaskIds) =>
                        updateTask.mutateAsync({ blockedByTaskIds })
                    }
                />
            ),
        },
        {
            label: "Blocking",
            content: (
                <BlockingSection
                    task={task}
                    onBlockingChange={(blockingTaskIds) =>
                        updateTask.mutateAsync({ blockingTaskIds })
                    }
                />
            ),
        },
        {
            label: "Related tasks",
            content: (
                <RelatedSection
                    task={task}
                    onRelatedChange={(relatedTaskIds) =>
                        updateTask.mutateAsync({ relatedTaskIds })
                    }
                />
            ),
        },
    ];
};
